export default __webpack_public_path__ + "static/carousell-os-car-valuation-min-10883fb8d42d64ac9a3d28473e62ee39.png";